import Badge from 'antd/lib/badge';

export default Badge;
